import styled from "styled-components";

export const StyledLinksGroup = styled.div<{
  visible?: boolean;
}>`
  padding: 0 0 2rem 0;
  display: flex;
  flex-direction: column;
  margin-right: 2px;
  background-color: #fff;

  .nav-category {
    .nav-category-title {
      margin: 16px 1.7rem 16px 1.7rem;
      font-weight: 600;
      font-size: 1.4rem;
      text-transform: uppercase;
    }
  }
`;
